// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple-keyboard.japanese-left {
  width: 240px !important;
}

.simple-keyboard.japanese-right {
  width: 240px !important;
  /* Tall enough for the 5-row segment-navigation layout, so switching in and
     out of it doesn't resize (and jump) the whole keyboard. */
  min-height: 360px;
}

.simple-keyboard.fb-keyboard.japanese-middle .hg-rows {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row {
  gap: 2px;
  height: 100%;
  display: grid;
  margin-bottom: 0;
}

.simple-keyboard.fb-keyboard.japanese-middle.numbers .hg-rows .hg-row {
  grid-template-columns: repeat(5, minmax(0, 1fr)) 2px repeat(3, minmax(0, 1fr));
}

.simple-keyboard.fb-keyboard.japanese-middle.abc .hg-rows .hg-row {
  grid-template-columns: repeat(10, minmax(0, 1fr));
}

.simple-keyboard.fb-keyboard.japanese-middle.kana .hg-rows .hg-row {
  grid-template-columns: repeat(1, minmax(0, 1fr)) 2px repeat(5, minmax(0, 1fr)) 2px repeat(5, minmax(0, 1fr));
}

.simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button {
  margin-right: 0 !important;
  width: auto;
  height: 100%;
  box-shadow: none!important;
  border-radius: 0;
}

.simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button.keyboard-divider {
  max-width: 8px !important;
  min-width: 8px !important;
  flex-grow: 0 !important;
  flex-shrink: 0 !important;
  pointer-events: none !important;
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  padding: 0 !important;
  margin: 0 6px !important;
  position: relative !important;
}

.simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button.keyboard-divider span {
  display: none !important;
}

.simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button.active {
  background-color: #d1d5db !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Keyboard/Custom/Japanese/japanese.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB;8DAC4D;EAC5D,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,4GAA4G;AAC9G;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,kCAAkC;EAClC,2BAA2B;EAC3B,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".simple-keyboard.japanese-left {\n  width: 240px !important;\n}\n\n.simple-keyboard.japanese-right {\n  width: 240px !important;\n  /* Tall enough for the 5-row segment-navigation layout, so switching in and\n     out of it doesn't resize (and jump) the whole keyboard. */\n  min-height: 360px;\n}\n\n.simple-keyboard.fb-keyboard.japanese-middle .hg-rows {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row {\n  gap: 2px;\n  height: 100%;\n  display: grid;\n  margin-bottom: 0;\n}\n\n.simple-keyboard.fb-keyboard.japanese-middle.numbers .hg-rows .hg-row {\n  grid-template-columns: repeat(5, minmax(0, 1fr)) 2px repeat(3, minmax(0, 1fr));\n}\n\n.simple-keyboard.fb-keyboard.japanese-middle.abc .hg-rows .hg-row {\n  grid-template-columns: repeat(10, minmax(0, 1fr));\n}\n\n.simple-keyboard.fb-keyboard.japanese-middle.kana .hg-rows .hg-row {\n  grid-template-columns: repeat(1, minmax(0, 1fr)) 2px repeat(5, minmax(0, 1fr)) 2px repeat(5, minmax(0, 1fr));\n}\n\n.simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button {\n  margin-right: 0 !important;\n  width: auto;\n  height: 100%;\n  box-shadow: none!important;\n  border-radius: 0;\n}\n\n.simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button.keyboard-divider {\n  max-width: 8px !important;\n  min-width: 8px !important;\n  flex-grow: 0 !important;\n  flex-shrink: 0 !important;\n  pointer-events: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  padding: 0 !important;\n  margin: 0 6px !important;\n  position: relative !important;\n}\n\n.simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button.keyboard-divider span {\n  display: none !important;\n}\n\n.simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button.active {\n  background-color: #d1d5db !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
